/** Equal-temperament helper for the chromatic 808 set and the bass patches. */

const NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'] as const;

/** MIDI note number to hertz, A4 = 440. The reference every tuning check measures against. */
export function noteFrequency(midi: number): number {
  return 440 * Math.pow(2, (midi - 69) / 12);
}

/** "C#1" — the name a producer reads on a pad. */
export function noteName(midi: number): string {
  return `${NAMES[((midi % 12) + 12) % 12]!}${Math.floor(midi / 12) - 1}`;
}

/**
 * "cs1" — the same note as a file-safe slug. A `#` is a fragment marker in a URL and gets
 * mangled by half the tools that touch it, so it is spelled out.
 */
export function noteSlug(midi: number): string {
  const name = NAMES[((midi % 12) + 12) % 12]!;
  const letter = name.endsWith('#') ? `${name.slice(0, -1).toLowerCase()}s` : name.toLowerCase();
  return `${letter}${Math.floor(midi / 12) - 1}`;
}
